import { Chip } from '@mui/material';
import { BulkParseResult } from '../../../hooks/BulkUpload/parseBulkCodes';
import { MAX_SHIPPINGS_PER_BATCH } from '../../../config/batchLimits';

interface ParseStatsChipsProps {
  stats: BulkParseResult['stats'];
}

const ParseStatsChips = ({ stats }: ParseStatsChipsProps) => {
  const isOverLimit = stats.validCount > MAX_SHIPPINGS_PER_BATCH;
  const detectedLabel = `${stats.validCount} pedido${stats.validCount !== 1 ? 's' : ''} detectado${stats.validCount !== 1 ? 's' : ''}`;

  return (
    <div className='flex flex-wrap gap-2'>
      <Chip
        size='small'
        color={isOverLimit ? 'error' : stats.validCount > 0 ? 'success' : 'default'}
        label={
          isOverLimit
            ? `${detectedLabel} · máximo ${MAX_SHIPPINGS_PER_BATCH} por tanda`
            : detectedLabel
        }
      />
      {stats.duplicateCount > 0 && (
        <Chip
          size='small'
          color='warning'
          label={`${stats.duplicateCount} duplicado${stats.duplicateCount !== 1 ? 's' : ''} omitido${stats.duplicateCount !== 1 ? 's' : ''}`}
        />
      )}
      {stats.unrecognizedCount > 0 && (
        <Chip
          size='small'
          color='error'
          label={`${stats.unrecognizedCount} línea${stats.unrecognizedCount !== 1 ? 's' : ''} no reconocida${stats.unrecognizedCount !== 1 ? 's' : ''}`}
        />
      )}
    </div>
  );
};

export default ParseStatsChips;
